import { createElement } from 'react';

export default Component => () => props => createElement(Component, props);
